module.exports = __webpack_public_path__ + "static/media/address_image.d0f3c312.svg";